module.exports = __webpack_public_path__ + "img/FGr_Führung-Kommunikation_A.6cd0105c.svg";